import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { createComponents } from './markdown-components';
import { type TableData } from '../markdown-table/lib';
const remarkPlugins = [remarkGfm];
export type MarkdownProps = {
  children: string;
  className?: string;
  onExpandTable?: (tableData: TableData) => void;
  messageUuid?: string;
  prefix?: string;
};
function NonMemoizedMarkdown(t0) {
  const $ = _c(8);
  const {
    children,
    className,
    onExpandTable,
    messageUuid,
    prefix
  } = t0;
  let t1;
  if ($[0] !== messageUuid || $[1] !== onExpandTable || $[2] !== prefix) {
    t1 = createComponents(messageUuid, onExpandTable, prefix);
    $[0] = messageUuid;
    $[1] = onExpandTable;
    $[2] = prefix;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== className || $[6] !== t1) {
    t2 = <ReactMarkdown remarkPlugins={remarkPlugins} components={t1} className={className}>{children}</ReactMarkdown>;
    $[4] = children;
    $[5] = className;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export const Markdown = memo(NonMemoizedMarkdown, (prevProps, nextProps) => prevProps.children === nextProps.children);